export const getBase64 = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string); // guaranteed to be a string because readAsDataURL returns "data:..." string.
    reader.onerror = (error) => reject(error);
  });
};
